import { useState } from 'react'
import ScontiService from '../services/ScontiService/ScontiService';
import { alertService } from '../services/AlertService';
import { handleError } from '../model/handleError';

const useSconti = () => {
  const [loadingState, setLoadingState] = useState({
    isLoadingSconti: false,
    isLoadingScontoCreating: false,
    isLoadingScontoDeleting: false,
    isLoadingScontoByIdCorso: false,
    isLoadingVoucherByIdCorso: false//NEW
  });

  const [modalState, setModalState] = useState({
    showModalCreateSconto: false
  });

  const getScontiByIdUtente = async (id_utente) => {
    setLoadingState(prev => ({ ...prev, isLoadingSconti: true }));
    try {
      const response = await ScontiService.getScontiByIdUtente(id_utente);
      return response;
    } catch (err) {
      handleError(err);
      return [];
    } finally {
      setLoadingState(prev => ({ ...prev, isLoadingSconti: false }));
    }
  }

  const createSconto = async (data) => {
    setLoadingState({ ...loadingState, isLoadingScontoCreating: true });
    try {
      const response = await ScontiService.createSconto(data);
      alertService.success("Sconto assegnato con successo", {autoClose: true});
      setModalState({...modalState, showModalCreateSconto: false });
      return response;
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState({ ...loadingState, isLoadingScontoCreating: false });
    }
  }

  const deleteSconto = async (id_sconto) => {
    setLoadingState({ ...loadingState, isLoadingScontoDeleting: true });
    try {
      await ScontiService.deleteSconto(id_sconto);
      alertService.success("Sconto eliminato con successo", {autoClose: true});
      return true;
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState({ ...loadingState, isLoadingScontoDeleting: false });
    }
  }

  const getScontoByIdCorso = async (data) => {
    setLoadingState({ ...loadingState, isLoadingScontoByIdCorso: true });
    try {
      const response = await ScontiService.getScontoByIdCorso(data);
      return response;
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState({ ...loadingState, isLoadingScontoByIdCorso: false });
    }
  }

  const getVoucherByIdCorso = async (data) => {//NEW
    setLoadingState({ ...loadingState, isLoadingVoucherByIdCorso: true });
    try {
      const response = await ScontiService.getVoucherByIdCorso(data);
      return response;
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState({ ...loadingState, isLoadingVoucherByIdCorso: false });
    }
  }

  return {
    loadingStateSconti: loadingState,
    loadingStateVoucher: loadingState,//NEW
    modalStateSconti: modalState,
    getScontoByIdCorso,
    getVoucherByIdCorso,//NEW
    setModalStateSconti: setModalState,
    getScontiByIdUtente,
    createSconto,
    deleteSconto
  };      
}

export default useSconti;
